import * as React from "react";

function IconLOPro(props) {
  return (
    <svg width={48} height={48} viewBox="0 0 72 72" fill="none" {...props}>
  <circle cx={35.625} cy={36.375} r={34.875} fill="#f51e84" />
  <circle
    cx={35.625}
    cy={36.375}
    r={34.375}
    stroke="#000"
    strokeOpacity={0.08}
  />
  <g clipPath="url(#prefix__clip0_1554_509)" fill="#fff">
    <path d="M47.313 31.374v-4.733h-3.359V24.09h-2.373v2.552h-3.358v4.733h-1.786v-9.018h-2.881V17.69h-3.85V15h-2.373v2.69h-3.85v4.666h-2.88V55.5h29.294V31.374h-2.584zm-6.717-2.36h4.344v2.36h-4.344v-2.36zm-14.74-8.951h5.327v2.293h-5.326v-2.294zm8.207 11.311v21.753H22.976V24.729h11.087v6.645zm13.461 21.753H36.437v-19.38h11.087v19.38z" />
    <path d="M27.451 26.628h-2.373v2.4h2.373v-2.4zM31.96 26.628h-2.373v2.4h2.373v-2.4zM27.451 31.058h-2.373v2.399h2.373v-2.4zM31.96 31.058h-2.373v2.399h2.373v-2.4zM27.451 35.487h-2.373v2.4h2.373v-2.4zM31.96 35.487h-2.373v2.4h2.373v-2.4zM27.451 39.917h-2.373v2.4h2.373v-2.4zM31.96 39.917h-2.373v2.4h2.373v-2.4zM27.451 44.347h-2.373v2.4h2.373v-2.4zM31.96 44.347h-2.373v2.4h2.373v-2.4zM27.451 48.776h-2.373v2.4h2.373v-2.4zM31.96 48.776h-2.373v2.4h2.373v-2.4zM40.992 35.487h-2.373v2.4h2.373v-2.4zM45.5 35.487h-2.372v2.4H45.5v-2.4zM40.992 39.917h-2.373v2.4h2.373v-2.4zM45.5 39.917h-2.372v2.4H45.5v-2.4zM40.992 44.347h-2.373v2.4h2.373v-2.4zM45.5 44.347h-2.372v2.4H45.5v-2.4zM40.992 48.776h-2.373v2.4h2.373v-2.4zM45.5 48.776h-2.372v2.4H45.5v-2.4z" />
  </g>
  <defs>
    <clipPath id="prefix__clip0_1554_509">
      <path fill="#fff" transform="translate(15 15)" d="M0 0h40.5v40.5H0z" />
    </clipPath>
  </defs>
</svg>




  );
}

const MemoIconLOPro = React.memo(IconLOPro);
export default MemoIconLOPro;
